import api from './api';

/** Informations d'en-tête de l'entreprise (tickets, factures, bons de commande). */
export interface InfosEntreprise {
  nom: string;
  adresse: string;
  ville: string;
  telephone: string;
  email: string;
  ifu: string;
  rccm: string;
  siteWeb: string;
  piedPage: string;
}

const CLE_CACHE = 'nexacom_entreprise';
let cacheMemoire: InfosEntreprise | null = null;

function mapper(e: any): InfosEntreprise {
  return {
    nom: e?.nom || '',
    adresse: e?.adresse || '',
    ville: e?.ville || '',
    telephone: e?.telephone || '',
    email: e?.email || '',
    ifu: e?.ifu || '',
    rccm: e?.rccm || '',
    siteWeb: e?.siteWeb || '',
    piedPage: e?.piedPage || '',
  };
}

export const entrepriseService = {
  /**
   * Infos de l'entreprise de l'utilisateur connecté (GET /entreprises/moi),
   * avec cache mémoire + localStorage en secours (impression hors connexion API).
   */
  async getInfos(): Promise<InfosEntreprise> {
    if (cacheMemoire) return cacheMemoire;
    try {
      const res = await api.get('/entreprises/moi');
      cacheMemoire = mapper(res.data);
      localStorage.setItem(CLE_CACHE, JSON.stringify(cacheMemoire));
      return cacheMemoire;
    } catch {
      const local = localStorage.getItem(CLE_CACHE);
      if (local) {
        cacheMemoire = JSON.parse(local);
        return cacheMemoire as InfosEntreprise;
      }
      return mapper(null);
    }
  },

  /** Adresse complète sur une ligne (adresse + ville si présente). */
  adresseComplete(infos: InfosEntreprise): string {
    return [infos.adresse, infos.ville].filter(Boolean).join(', ');
  },

  /** À appeler après une sauvegarde des paramètres pour recharger à la prochaine demande. */
  invaliderCache(): void {
    cacheMemoire = null;
    localStorage.removeItem(CLE_CACHE);
  },
};
